import tw from 'twin.macro';

export const FindPlaceImageContent = tw.div`
  relative w-full flex flex-col items-start justify-center px-[1rem] pt-[2.5rem] gap-4`;

export const FindPlaceImageClue = tw.div`
  w-full flex flex-wrap items-center justify-between gap-1 mt-3 mb-2
`;
